import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { MimeType } from './file/MimeType';

const fetchAndZip = async (urls, setDownloadProgress, setShowDownloadDropdown, request, handleFailedDownload) => {
    try {
        // cleaning up previous iteration
        const zip = new JSZip();
        const fsnNames: string[] = [];
        setDownloadProgress(0, 0, '');

        setShowDownloadDropdown(true);

        for (let i = 0; i < urls.length; i++) {
            const modelurl = urls[i].url;
            const response = await fetch(modelurl);
            setDownloadProgress(i + 1, urls.length, request);
            const glbData = await response.blob();
            fsnNames.push(urls[i].name);
            zip.file(`${urls[i].name}.glb`, glbData);
        }

        const correspondingCsv = new Blob([fsnNames.join('\n')], { type: MimeType.CSV });

        zip.file(`request-${request}-downloaded-fsns.csv`, correspondingCsv);

        zip.generateAsync({ type: 'blob', mimeType: MimeType.GLB }).then(function (content) {
            saveAs(content, `request-${request}.zip`);
        });
    } catch (error) {
        handleFailedDownload(error);
    }
};

export default fetchAndZip;
